import React from 'react';

function DateConfirmModal(props) {
  return (
    <div className="container-rdv-modal">
      <div className="background-rdv-modal">
        <div className="modal-rdv confirmation-rdv">
          <div className="cup-image"></div>
          <div className="request-title-details">
            <div className="request-title">Demande envoyée</div>
            <div className="request-detail">
              Vous allez recevoir une confirmation par email prochainement.
            </div>
            <div className="request-detail">
              <br />
              Les propositions de dates de rendez-vous ont été transmises au
              client et sont en attente de son acceptation.
              <br />
            </div>
          </div>
          <div
            className="request-button"
            onClick={() => props?.closeConfirmation()}
          >
            Revenir a mes demandes
          </div>
        </div>
      </div>
    </div>
  );
}

export default DateConfirmModal;
